import { BatchFailure } from '@/shared/hooks/useBatchedRequests';

export enum TemplateKey {
  SKUS = 'skus_v6',
  ASNS = 'asns_v2',
  ORDERS = 'orders_v2',
}

export type CreatedRecord = Record<string, any>;
export type ErrorRecord = BatchFailure<Record<string, any>>;
